export const monthsAsObject = {
    '01': 'Janvier',
    '02': 'Février',
    '03': 'Mars',
    '04': 'Avril',
    '05': 'Mai',
    '06': 'Juin',
    '07': 'Juillet',
    '08': 'Août',
    '09': 'Septembre',
    '10': 'Octobre',
    '11': 'Novembre',
    '12': 'Décembre',
}

export const monthAsArray = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
]

export const shortMonths = {
    '01': 'Janv',
    '02': 'Févr',
    '03': 'Mars',
    '04': 'Avr',
    '05': 'Mai',
    '06': 'Juin',
    '07': 'Juill',
    '08': 'Août',
    '09': 'Sept',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Déc',
}

const vowels = ['A', 'O']

const getStarter = (letter: string) => {
    if (vowels.includes(letter)) {
        return "D'"
    }

    return 'De '
}

export const getPlaceholderDates = (startDate: Date, endDate: Date) => {
    if (startDate.getTime() === endDate.getTime()) {
        const year = endDate.getFullYear()
        const month = endDate.getMonth()
        const period = monthAsArray[month] + ' ' + year

        return period
    } else {
        const startDateMonth = startDate.getMonth()
        const startDateYear = startDate.getFullYear()
        const endDateMonth = endDate.getMonth()
        const endDateYear = endDate.getFullYear()

        const period = `${getStarter(monthAsArray[startDateMonth][0])}${monthAsArray[startDateMonth]
            } ${startDateYear} à ${monthAsArray[endDateMonth]} ${endDateYear}`

        return period
    }
}

export const getDefaultPeriod = () => {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = monthsAsObject[currentDate.getMonth() + 1]

    return `De Janvier ${currentYear} à  ${currentMonth}  ${currentYear}`
}


export const getLast3Months = (startDate: Date, maxDate: Date) => {

    const months: Date[] = [];

    for (let i = 0; i < 3; i++) {
        const current = new Date(maxDate.getFullYear(), maxDate.getMonth() - i, 1);
        if (current >= startDate) {
            months.unshift(current); // ajoute en début pour garder l’ordre croissant
        }
    }

    return {
        start: months[0],
        end: months[months.length - 1],
    };
}

export const getCurrentYear = (startDate: Date, maxDate: Date) => {
    const targetYear = maxDate.getFullYear();
    const months: Date[] = [];

    for (
        let current = new Date(maxDate);
        current >= startDate;
        current.setMonth(current.getMonth() - 1)
    ) {
        if (current.getFullYear() === targetYear) {
            months.unshift(new Date(current.getFullYear(), current.getMonth(), 1));
        }
    }

    const end = new Date(months[months.length - 1].getFullYear(), months[months.length - 1].getMonth(), 1);
    return { start: months[0], end };
}

export const hasThreeFullConsecutiveMonths = (start: Date, end: Date): boolean => {

    const expectedStart = new Date(end.getFullYear(), end.getMonth() - 2, 1);

    return start.getTime() === expectedStart.getTime();
};